import { createFileRoute } from "@tanstack/react-router";
import { AgentPermissionsIndexRoute } from "@/components/agents/agent-permissions-route";
import { useAgents, useWorkspaceRoot } from "@/lib/api";

export const Route = createFileRoute("/$owner/agents/$agentId/permissions")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
		void queryClient.prefetchQuery(useAgents.queryOptions(params.owner));
	},
	component: AgentPermissionsPage,
});

function AgentPermissionsPage() {
	const { owner, agentId } = Route.useParams();
	return <AgentPermissionsIndexRoute owner={owner} agentId={agentId} />;
}
